import { useEffect, useEffectEvent, useRef, useState } from 'react';

import { cancelIdle, requestIdle } from '@/utils/idle-callback';

export function useInitState(options?: { timeout?: number }) {
  const { timeout = 1000 } = options ?? {};
  const timeoutRef = useRef(timeout);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const initApp = useEffectEvent(() => {
    setIsInitialRender(false);
  });

  useEffect(() => {
    let idleCallback: number;
    if (isInitialRender) {
      idleCallback = requestIdle(initApp, {
        timeout: timeoutRef.current,
      });
    }

    return () => {
      if (idleCallback !== undefined && idleCallback !== null) {
        cancelIdle(idleCallback);
      }
    };
  }, [isInitialRender]);

  return { isInitialRender };
}
